var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.updateAvailable)?_c('div',{staticClass:"updateAvailable notify notify-bottom-right",attrs:{"pointer":""},on:{"click":function($event){return _vm.helperUpdateRefresh()}}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"notify-item",staticStyle:{"display":"block"}},[_c('div',{staticClass:"notification notification--info"},[_vm._v(" Na voljo je nova posodobitev ")])])])
}]

export { render, staticRenderFns }